<template>
    <ies-form-field :field="field">
        <!-- list must be list of ['text' => x, 'value' => y] -->
        <v-autocomplete hide-details dense outlined
            v-model="viewValue"
            :items="facilities"
            autocomplete
        ></v-autocomplete>
        <input type="hidden" :name="field.fieldName" :value="field.value">
    </ies-form-field>

</template>

<script>
    import axios from 'axios';
    /**
     * Allows the selection of a facility ID by choosing its name from
     * a selection downloaded from the API on creation
     */
    export default {
        name: 'ies-facilityKey',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                facilities: [],
                viewValue: parseInt(this.field.value),
            }
        },
        created:function() {
            this.getFacilities();
        },
        methods: {
            getFacilities:function(){
                axios.get('/api/facilities')
                .then(function(response){
                    var facilities = [];
                    response.data.forEach(function(record){
                        facilities.push({ text: record.title, value: record.facility_key });
                    });
                    this.facilities = facilities;
                }.bind(this));
            },
        },
        watch: {
            viewValue: function (newValue) {
                this.field.value = newValue;
            }
        }
    }
</script>
